var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "paper",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.381,
    height: 14.915,
    viewBox: "0 0 14.381 14.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M17.436,10.722a.266.266,0,0,0-.266.266v7.366a1.2,1.2,0,0,1-.414-.2,1.663,1.663,0,0,0-1.955,0,1.129,1.129,0,0,1-1.363,0,1.663,1.663,0,0,0-1.952,0,1.121,1.121,0,0,1-1.366,0,1.668,1.668,0,0,0-1.955,0,1.208,1.208,0,0,1-.417.205V9.8s0-4.424,0-4.425a1.359,1.359,0,0,0-.3-.84h6.024a.266.266,0,0,0,0-.533h-7.1A1.374,1.374,0,0,0,5,5.373V14.5a1.1,1.1,0,0,0,1.1,1.1h.276a.266.266,0,1,0,0-.533H6.1a.564.564,0,0,1-.563-.563V5.373a.84.84,0,1,1,1.68,0V18.648a.266.266,0,0,0,.266.266,1.58,1.58,0,0,0,.979-.322,1.13,1.13,0,0,1,1.364,0,1.668,1.668,0,0,0,1.958,0,1.051,1.051,0,0,1,.68-.232c.766.026.777.568,1.659.554.88.014.893-.529,1.659-.554.766.026.776.568,1.657.554a.266.266,0,0,0,.266-.266v-7.66a.266.266,0,0,0-.266-.266Z",
    transform: "translate(-5.002 -4)",
    fill: "#00aeef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M21.333,15H17.726a.266.266,0,1,0,0,.533h3.606a.266.266,0,1,0,0-.533Z",
    transform: "translate(-14.142 -12.07)",
    fill: "#00aeef"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M22.409,25.23H17.726a.266.266,0,1,0,0,.533h4.682a.266.266,0,1,0,0-.533Z",
    transform: "translate(-14.142 -19.576)",
    fill: "#00aeef"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M25.473,35.461H17.728a.266.266,0,1,0,0,.533h7.744a.266.266,0,1,0,0-.533Z",
    transform: "translate(-14.143 -27.082)",
    fill: "#00aeef"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M17.728,45.692a.266.266,0,1,0,0,.533h7.744a.266.266,0,1,0,0-.533Z",
    transform: "translate(-14.143 -34.588)",
    fill: "#00aeef"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M38.195,4a3.2,3.2,0,1,0,3.2,3.2,3.2,3.2,0,0,0-3.2-3.2Zm0,5.859A2.663,2.663,0,1,1,40.858,7.2,2.666,2.666,0,0,1,38.195,9.86Z",
    transform: "translate(-27.01 -4)",
    fill: "#00aeef"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M43.695,10.965H42.5v-1.2a.266.266,0,1,0-.533,0v1.2h-1.2a.266.266,0,0,0,0,.533h1.2v1.2a.266.266,0,1,0,.533,0V11.5h1.2a.266.266,0,1,0,0-.533Z",
    transform: "translate(-31.045 -8.035)",
    fill: "#00aeef"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.260feee1a4e425b35cad8b32d9cf37f8.svg";
export { ForwardRef as ReactComponent };